import type { RouteLocationRaw } from '#vue-router'

export const TRIAL_ACCESS_ROUTE: RouteLocationRaw = { name: 'info-page', params: { slug: 'kontakt-salgsavdelingen' } }

export const TRIAL_ACCESS_LABEL = 'Få prøvetilgang'
